<template>
    <div class="card">
        <div class="px-2">
          <ul class="nav nav-tabs">
            <li v-for="tab in tabs" :key="tab.id" class="nav-item">
              <a
                  :class="['nav-link', { active: activeTab.id == tab.id }]"
                  @click="setActiveTab(tab)"
              >
                {{ tab.title }}
              </a>
            </li>
          </ul>
        </div>

        <div class="col-12 px-2 mt-2 mb-5">
            <component :is="tabComponents[activeTab.id]"
                :service="service" 
                :receiptGenerals="receiptGenerals" 
                :total="total" 
                :patientDetails="patientDetails" 
                :companyInfo="companyInfo"
            />
        </div>

        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
    import Statement from '@/components/molecule/company/dental-os/ipd-bill/IpdStatementTable.vue';
    import MoneyReceipts from "@/components/molecule/company/dental-os/ipd-bill/MoneyReceipts";
    import { useRoute, useRouter } from "vue-router";
    import { onMounted, ref } from 'vue'; 
    import handleHospital from '@/services/modules/hospital';
    import Loader from '@/components/atom/LoaderComponent';
    import ipdStatementHelper from '@/services/utils/pdf/ipdStatementHelper';
    import handleCompany from "@/services/modules/company";
    import DentalIpdBilling from '@/components/molecule/company/dental-os/service/billing/DentalIpdBilling.vue';

    const $route = useRoute();
    const $router = useRouter();

    const { fetchIpdStatement, calculateAge } = handleHospital();
    const { generatePdf } = ipdStatementHelper();
    const { fetchCompanyInfo } = handleCompany();

    const patientDetails = ref({});
    const service = ref([]);
    const loading = ref(false);
    const receiptGenerals = ref([]);
    const total = ref({});
    const companyInfo = ref({});

    const tabs = [
      { id: 'statement', title: 'Statements' },
      { id: 'ipd-bill', title: 'Bill' },
      { id: 'money-receipts', title: 'MoneyReceipts' },
    ];

    const tabComponents = {
      'statement': Statement,
      'money-receipts': MoneyReceipts,
      'ipd-bill': DentalIpdBilling
    };

    const activeTab = ref(tabs[0]);

    const getQuery = () => {

        const ipdRegisterId = $route.params.ipdRegisterId || $route.query.ipd_register_id;

        let query = `/${ipdRegisterId}?company_id=${$route.params.companyId}`;
        return query;
    }

    onMounted(() => {
        const query = getQuery();
        loading.value = true;

        Promise.all([
            fetchIpdStatement(query).then((res) => {
                patientDetails.value = res.data;
                service.value = res.service_data;
                receiptGenerals.value = res.receipt_generals;
                total.value = res.total;
                total.value.settlement_discount = res.data.settlement_discount;
            }),
            fetchCompanyInfo($route.params.companyId).then((res) => {
                companyInfo.value = res.data
            })
        ]).catch(err => {
            console.log(err)
        }).finally(() => {
            loading.value = false;
        })
    })

    const setActiveTab = (tab) => {
        activeTab.value = tab;
        const routerObject = {
            path: $route.path,
            query: {
              ...$route.query,
              tab: tab.id
            }
        };

        if ($route.hash) {
            routerObject.hash = $route.hash;
        }

        $router.replace(routerObject);
    };

    onMounted(() => {
        const currentTab = $route.query.tab || 'statement';

        if(! currentTab || ! tabs.map(tab => tab.id).includes(currentTab)) return;
        activeTab.value = tabs.find(tab => tab.id === currentTab);
    })
</script>